<template>
  <div id="nova">
    <MainHeader />

    <!-- Content -->
    <div dusk="content">
      <div
        v-if="!mainMenuCollapsed"
        class="hidden lg:block lg:absolute left-0 bottom-0 lg:top-[56px] lg:bottom-auto w-60 px-3 py-8"
      >
        <!-- The Main Menu on desktop gets extra padding to keep the bottom of the sidebar from feeling crowded -->
        <MainMenu class="pb-24" data-screen="desktop" />
      </div>

      <transition
        enter-active-class="transition duration-150 ease-out"
        enter-from-class="-translate-x-full opacity-0"
        enter-to-class="translate-x-0 opacity-100"
        leave-active-class="transition duration-150 ease-in"
        leave-from-class="translate-x-0 opacity-100"
        leave-to-class="-translate-x-full opacity-0"
      >
        <div
          v-if="mainMenuCollapsed && mainMenuPreviewShown"
          class="hidden lg:block fixed left-0 z-50 w-60 px-3 py-8 bg-white dark:bg-gray-800 shadow-lg overflow-y-auto"
          style="top: 56px; bottom: 0"
          @mouseenter="showMainMenuPreview"
          @mouseleave="queueHideMainMenuPreview"
        >
          <MainMenu class="pb-24" data-screen="desktop-preview" />
        </div>
      </transition>

      <div
        class="nova-main-content p-4 md:py-8 md:px-12 lg:ml-60 space-y-8"
        :class="{ 'lg:!ml-0': mainMenuCollapsed }"
      >
        <Breadcrumbs v-if="breadcrumbsEnabled" />

        <FadeTransition>
          <slot />
        </FadeTransition>

        <Footer />
      </div>
    </div>
  </div>
</template>

<script>
import MainHeader from '@/layouts/MainHeader'
import Footer from '@/layouts/Footer'

export default {
  components: {
    MainHeader,
    Footer,
  },

  mounted() {
    Nova.$on('error', this.handleError)
    Nova.$on('token-expired', this.handleTokenExpired)
  },

  beforeUnmount() {
    Nova.$off('error', this.handleError)
    Nova.$off('token-expired', this.handleTokenExpired)
  },

  methods: {
    handleError(message) {
      Nova.error(message)
    },

    handleTokenExpired() {
      // @TODO require Nova._createToast() to support action with link.
      Nova.$toasted.show(this.__('Sorry, your session has expired.'), {
        action: {
          onClick: () => Nova.redirectToLogin(),
          text: this.__('Reload'),
        },
        duration: null,
        type: 'error',
      })

      setTimeout(() => {
        Nova.redirectToLogin()
      }, 5000)
    },

    showMainMenuPreview() {
      this.$store.dispatch('showMainMenuPreview')
    },

    queueHideMainMenuPreview() {
      this.$store.dispatch('queueHideMainMenuPreview')
    },
  },

  computed: {
    breadcrumbsEnabled() {
      return Nova.config('breadcrumbsEnabled')
    },

    mainMenuCollapsed() {
      return this.$store.getters.mainMenuCollapsed
    },

    mainMenuPreviewShown() {
      return this.$store.getters.mainMenuPreviewShown
    },
  },
}
</script>

<style>
@media (min-width: 1024px) {
  #nova > div[dusk='content'] > .nova-main-content.p-4.md\:py-8.lg\:ml-60.space-y-8 {
    padding-left: 5px !important;
    padding-right: 5px !important;
  }
}
</style>
